import { takeLatest, put, call } from "redux-saga/effects";
// import { ShowError, ShowSucess } from '../../../_helper/helper';
import { ShowError, ShowSucess } from '../../_helper/helper';

import {
    NEWLEAVEREQUESTCREATE,
    NEWLEAVEREQUESTCREATE_FAIL,
    NEWLEAVEREQUESTCREATE_SUCCESS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_SUCCESS,
    GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS_FAIL,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
    UPDATE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST_SUCCESS,
    DELETE_NEWLEAVESHAREREQUEST_REQUEST_FAIL,
    Get_Audit_Trail,
    Get_Audit_Trail_History
} from "./actionTypes";

import { createNEWLEAVESHAREREQUESTRequestSuccess, createNEWLEAVESHAREREQUESTRequestFail, getNEWLEAVESHAREREQUESTRequestDetailsSuccess, getNEWLEAVESHAREREQUESTRequestDetailsFail, updateNEWLEAVESHAREREQUESTRequestSuccess, auditTrailRequestSuccess, auditTrailRequestFail, auditTrailHistoryRequestSuccess, auditTrailHistoryRequestFail } from "./action";

import {
    leaveShareAuditTrail,
    leaveShareAuditTrailHistory,
    newLeaveShareByRecipientCreate,
    newLeaveShareByRecipientList,
    newLeaveShareByRecipientUpdate
} from "../../_helper/services/LeaveShareMgmt/leaveShareRequest";


function* onCreateLeaveRequest({ payload }) {
    try {
        const response = yield call(newLeaveShareByRecipientCreate, payload);
        yield put(createNEWLEAVESHAREREQUESTRequestSuccess(response));
        ShowSucess("Leave Requested Succesfully", { position: "top-right" })
    }
    catch (error) {
        yield put(createNEWLEAVESHAREREQUESTRequestFail(error.response));
        ShowError("Data Already Exist", { position: "top-right" });
    } 
}

function* onGetLeaveShare() {
    try {
        const response = yield call(newLeaveShareByRecipientList);
        yield put(getNEWLEAVESHAREREQUESTRequestDetailsSuccess(response));
    } catch (error) {
        yield put(getNEWLEAVESHAREREQUESTRequestDetailsFail(error.response));
    }
}


// function* onGetLeaveShare({ payload: id }) {
//     try {
//         const response = yield call(newLeaveShareByRecipientList, id);
//         yield put(getNEWLEAVESHAREREQUESTRequestDetailsSuccess(response));
//     } catch (error) {
//         yield put(createNEWLEAVESHAREREQUESTRequestFail(error.response));
//     }
// }

function* onUpdateLeaveShare({ payload: { id }, payload }) {
    try {
        const response = yield call(newLeaveShareByRecipientUpdate, payload.hrcontrol, payload);
        yield put(updateNEWLEAVESHAREREQUESTRequestSuccess(response));
        yield put(getNEWLEAVESHAREREQUESTRequestDetailsSuccess(payload));
        // ShowSucess(`Details updated successfully`, { position: 'top-right' });
    } catch (error) {
        yield put(getNEWLEAVESHAREREQUESTRequestDetailsFail(error.response));
        ShowError(error?.response?.data?.message);
    }
}

function* onAuditTrailRequest({payload}) {
    try{
        const response = yield call(leaveShareAuditTrail,payload);
        yield put(auditTrailRequestSuccess(response))
    } catch (error) {
        yield put(auditTrailRequestFail(error.response))
    }
}

function* onAuditTrailHistoryRequest({payload}) {
    try{
        const response = yield call(leaveShareAuditTrailHistory,payload);
        yield put(auditTrailHistoryRequestSuccess(response))
    } catch (error) {
        yield put(auditTrailHistoryRequestFail(error.response))
    }
}

// function* onDeleteGrievanceRequest({ payload: id }) {
//     try {
//         const response = yield call(deleteGrievanceRequest, id);
//         yield put(deleteGrievanceRequestSuccess(response));
//         ShowSucess('Deleted successfully', { position: 'top-right' });
//     } catch (error) {
//         yield put(deleteGrievanceRequestFail(error.response));
//         ShowError(error?.response?.data?.message);
//     }
// }

function* NewLeaveRequestMgmt() {
    yield takeLatest(NEWLEAVEREQUESTCREATE, onCreateLeaveRequest);
    yield takeLatest(GET_NEWLEAVESHAREREQUEST_REQUEST_DETAILS, onGetLeaveShare);
    yield takeLatest(UPDATE_NEWLEAVESHAREREQUEST_REQUEST, onUpdateLeaveShare);
    yield takeLatest(Get_Audit_Trail,onAuditTrailRequest);
    yield takeLatest(Get_Audit_Trail_History,onAuditTrailHistoryRequest)
    // yield takeLatest(DELETE_GRIEVANCE_REQUEST, onDeleteGrievanceRequest);
}

export default NewLeaveRequestMgmt;